import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTablePaymentAmount extends Component<{ paymentAmount: string }> {
    render() {
        return <OptionalTableCell title='Payment Amount'>
            {this.props.paymentAmount}
        </OptionalTableCell>;
    }
}